export const formatCurrency = (
  value: number,
  options?: Intl.NumberFormatOptions,
) => {
  const newOptions = Object.assign(
    {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    options,
  )
  return new Intl.NumberFormat('pt-BR', newOptions).format(value)
}
